import { getDisplayPrice } from '~js/utils/utils';

const cartCountElement = document.getElementById('cart-item-count');
export const updateCartCount = (cartItemCount) => {
  if (cartCountElement) {
    cartCountElement.textContent = cartItemCount > 99 ? '99+' : cartItemCount;
  }
};

export const getProgressBarDetails = (cartState, cartConfig) => {
  const freeShippingAmount = Math.max(
    0,
    cartConfig.checkpoint_1_amount - cartState.subtotalVal,
  );
  const freeGiftAmount = Math.max(
    0,
    cartConfig.checkpoint_2_amount - cartState.subtotalVal,
  );
  const progressPercentage = Math.min(
    100,
    (cartState.subtotalVal / cartConfig.checkpoint_2_amount) * 100,
  );
  const freeShippingPosition = Math.min(
    100,
    (cartConfig.checkpoint_1_amount / cartConfig.checkpoint_2_amount) * 100,
  );

  let promotionText = '';
  const hasFreeShipping =
    cartState.subtotalVal >= cartConfig.checkpoint_1_amount;
  const hasFreeGift = cartState.subtotalVal >= cartConfig.checkpoint_2_amount;

  if (hasFreeGift) {
    promotionText = cartConfig.promo_3_text;
  } else if (hasFreeShipping) {
    promotionText = cartConfig.promo_2_text.replace(
      '[amount]',
      getDisplayPrice(freeGiftAmount, false),
    );
  } else {
    promotionText = cartConfig.promo_1_text.replace(
      '[amount]',
      getDisplayPrice(freeShippingAmount, false),
    );
  }

  return {
    promotionText,
    progressPercentage,
    freeShippingPosition,
    hasFreeShipping,
    hasFreeGift,
  };
};
